import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function for merging Tailwind CSS classes
 * Similar to shadcn/ui's cn() function
 */
export function cn(...inputs: (string | undefined | null | false)[]): string {
  return twMerge(classNames(inputs));
}
